export const getAvailableSlots = daySlots => daySlots.filter(item => item.available);
